
        export default [
  "brand_muckleshoot_color",
  "brand_wh_flips_coin_color",
  "brand_wh_flips_color",
  "brand_mountaineer_color",
  "brand_caesars_sportsbook_rewards_goblet_color",
  "brand_nfl_conference_afc_color",
  "brand_nfl_playoffs_color",
  "brand_caesars_sportsbook_muckleshoot_color",
  "brand_horseshoe_oc_color",
  "brand_mass_gaming_commission_color",
  "brand_nfl_conference_nfc_color",
  "brand_mlb_all_star_color",
  "brand_mlb_league_nl_color",
  "brand_mlb_league_al_color",
  "brand_mlb_playoffs_color",
  "brand_football_touchdown_color",
  "brand_nfl_pro_bowl_color",
  "brand_nba_all_star_color",
  "brand_nba_cup_color",
  "brand_nfl_championship_color",
  "brand_mlb_championship_color",
  "brand_nfl_draft_color",
  "brand_nba_championship_color",
  "brand_horseshoe_responsible_gaming_color",
  "brand_ontario_igaming_color",
  "brand_covers_color",
  "brand_nba_playoffs",
  "brand_horseshoe_color",
  "brand_nhl",
  "brand_william_hill_monogram_color",
  "brand_nfl",
  "brand_nba",
  "brand_mlb",
  "brand_william_hill_color",
  "brand_nba_conference_western_color",
  "brand_nba_conference_eastern_color",
  "brand_caesars_sportsbook_color",
  "brand_caesars_sportsbook_casino_color",
  "brand_caesars_racebook_horse_color",
  "brand_caesars_racebook_color",
  "brand_caesars_racebook_app_color",
  "brand_czr_goblet_app_color",
  "brand_wsop_color"
];  
      